import { useMemo } from 'react';
import type { useGetAssessmentById } from 'src/hooks/queries/assessment/useGetAssessmentById';
import type { useGetRiskById } from 'src/hooks/queries/risk/useGetRiskById';

type GetAssessmentByIdData = NonNullable<
  ReturnType<typeof useGetAssessmentById>['data']
>;
type GetRiskByIdData = NonNullable<ReturnType<typeof useGetRiskById>['data']>;

export const useGetAssessmentContributors = (
  assessmentData: GetAssessmentByIdData | undefined,
  risk: GetRiskByIdData | undefined,
  isUpdate?: boolean
) => {
  return useMemo(() => {
    return (
      assessmentData?.assessment[0].ancestorContributors
        .filter(
          (contributor) =>
            contributor.ContributorType === 'owner' ||
            contributor.ContributorType === 'contributor'
        )
        .map((contributor) => contributor.UserId)
        .filter((contributorId) => {
          const isRiskContributor = risk?.risk[0].ancestorContributors.some(
            (riskContributor) => riskContributor.UserId === contributorId
          );

          return isUpdate ? isRiskContributor : true;
        }) ?? []
    );
  }, [assessmentData, risk, isUpdate]);
};
